/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PersonName } from './personName';

export interface NaturalPerson {
  personName?: PersonName;
  /**
   * Unique identifier of gender
   */
  genderCode?: string;
  /**
   * Description of gender
   */
  genderDesc?: string;
  /**
   * Client's birthdate
   */
  birthdate?: Date;
  /**
   * Unique identifier of country of birth
   */
  countryBirthCode?: string;
  /**
   * Description of country of birth
   */
  countryBirthDesc?: string;
  /**
   * Code of place of birth (City)
   */
  townBirthCode?: string;
  /**
   * Description of place of birth (City)
   */
  townBirthDesc?: string;
  /**
   * Field to inform the person fiscal code. (6 letters, 2 numbers, 1 letter, 2 numbers, 1, letter, 3 numbers, 1 letter)
   */
  fiscalCode?: string;
  /**
   * Unique identifier of city of birth
   */
  cityBirthCode?: string;
  /**
   * Description of city of birth
   */
  cityBirthDesc?: string;
  piva?: string;
  maritalStatusCode?: string;
  maritalStatusDesc?: string;
  relationshipCode?: string;
  relationshipDesc?: string;
  professionCode?: string;
  professionDesc?: string;
  activitySectorCode?: string;
  activitySectorDesc?: string;
  driverLicenseTimeCode?: string;
  driverLicenseTimeDesc?: string;
  personType?: NaturalPerson.PersonTypeEnum;
}
export namespace NaturalPerson {
  export type PersonTypeEnum = 'PERSONA_FISICA' | 'PERSONA_GIURIDICA';
  export const PersonTypeEnum = {
    FISICA: 'PERSONA_FISICA' as PersonTypeEnum,
    GIURIDICA: 'PERSONA_GIURIDICA' as PersonTypeEnum,
  };
}
